import React, { useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../redux/actions';
import  CheckboxCustom  from '../../components/UI/CheckboxCustom/CheckboxCustom';
import show from '../../img/glaz.png';
import noshow from '../../img/nevidim.png';
import './RegisterPage.css'

export default function RegisterPage() {
    const [username, setUsername] = useState('');
    const [surname, setSurname] = useState('');
    const [name, setName] = useState('');
    const [patronymic, setPatronymic] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordTo, setPasswordTo] = useState('');
    const [hasError, setHasError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordTo, setShowPasswordTo] = useState(false);
    const [policyAgree, setPolicyAgree] = useState(0);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const error = useSelector(state => state.auth.error);

    useEffect(() => {
          dispatch({ type: 'REGISTER_CLEAR' });   
      }, [dispatch, error]);
      
    const handleSubmit=(e)=>{
         e.preventDefault();
         setHasError(true);
         const emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if ((username!== '') &&
            (surname!== '') &&
            (name!== '') &&
            (patronymic!== '') &&
            (email!== '') &&
            (emailRegex.test(email)) &&
            (password!== '') &&
            (passwordTo!== '') && 
            (password===passwordTo) &&
            (policyAgree===1)) {
         dispatch(registerUser(username, email, password,surname,name,patronymic, policyAgree));
         setHasError(false);
         navigate('/');
        } 
    }

    function handleCheckedPolitics(e) { 
        setPolicyAgree(1-policyAgree);
    }

    const togglePasswordVisibility = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
      };

    const togglePasswordToVisibility = (e) => {
        e.preventDefault();
        setShowPasswordTo(!showPasswordTo);
      };
    return(   
        
    <main className='RegisterCard-main-content'> 

         <div className='RegisterCard'> 

             <div className='RegisterCardHeader'>
                 <h2>Регистрация</h2>
                 {hasError && <h3 style={{color:'red'}}>ПРОВЕРЬТЕ ДАННЫЕ!</h3>}
             </div> 

        <div className='RegisterCardBody'> 

          <form className='RegisterForm'> 

             <div className='RegisterCardBlock'> 
                 <label className='RegisterCardLable'>📛 Логин</label>
                 <input type='text'className='RegisterCardInput'
                 placeholder="Придумайте логин"
                 value={username}
                 onChange={(e)=>setUsername(e.target.value)}></input> 
             </div>

             <div className='RegisterCardBlock'> 
                 <label className='RegisterCardLable'>👤 Фамилия</label>
                 <input type='text'className='RegisterCardInput'
                 placeholder="Фамилия"
                 value={surname}
                 onChange={(e)=>setSurname(e.target.value)}></input> 
             </div>

             <div className='RegisterCardBlock'> 
                 <label className='RegisterCardLable'>🧑 Имя</label>
                 <input type='text'className='RegisterCardInput'
                 placeholder="Имя"
                 value={name}
                 onChange={(e)=>setName(e.target.value)}></input> 
             </div>

             <div className='RegisterCardBlock'> 
                 <label className='RegisterCardLable'>📇 Отчество</label>
                 <input type='text'className='RegisterCardInput'
                 placeholder="Отчество"
                 value={patronymic}
                 onChange={(e)=>setPatronymic(e.target.value)}></input> 
             </div>

             <div className='RegisterCardBlock'> 
                 <label className='RegisterCardLable'>✉️ Email</label>
                 <input type='text' className='RegisterCardInput'
                 placeholder="Эл. почта"
                 value={email}
                 onChange={(e)=>setEmail(e.target.value)}></input> 
             </div>

             <div className='RegisterCardBlock'> 
                <div className='passwordVisibility'>
                    <label className='RegisterCardLable'>🔒 Пароль</label>
                    <button onClick={togglePasswordVisibility} className='btnVisibility'>
                        <img src={showPassword ? show : noshow} alt="Result" />  
                    </button>
                </div>
                 <input type={showPassword ? 'text' : 'password'}
                 className='RegisterCardInput'
                 placeholder="Создайте пароль"
                 value={password}
                 onChange={(e)=>setPassword(e.target.value)}></input> 
             </div>

            <div className='RegisterCardBlock'>
                <div className='passwordVisibility'>
                    <label className='RegisterCardLable'>🔁 Повторите пароль</label>
                    <button onClick={togglePasswordToVisibility} className='btnVisibility'>
                        <img src={showPasswordTo ? show : noshow} alt="Result" />  
                    </button>
                </div>
                <input type={showPasswordTo ? 'text' : 'password'}
                className='RegisterCardInput'
                placeholder="Введите пароль ещё раз"
                value={passwordTo}
                onChange={(e)=>setPasswordTo(e.target.value)}></input> 
            </div>
            
            <div className='RegisterCardPolitics'>
                <div className='RegisterCardPolitics-Accord'>
                <CheckboxCustom 
            size="large" 
            color="#4caf50"
            checked={policyAgree}
            onChange={handleCheckedPolitics}
             />
            {/* <p>Я ознакомлен(а) и согласен(на) с Политикой обработки персональных данных.
            Даю согласие на обработку моих персональных данных 
            (фамилии, имени, отчества, адреса электронной почты и логина)
             в целях регистрации и обслуживания моей учетной записи.</p> 
              */}
                    <div className='RegisterCardPolitics-Contents'> 
                        <p>Принимаю условия <a>Политики</a> и даю согласие на обработку данных.</p>
                    </div>
                </div>
                {/* <p> Необходимо принять условия для продолжения</p>  */}
            </div>

            </form>
        </div> 
       
       
         <div className='RegisterCardFooter'> 
             <div className='RegisterCardButton'> 
                 <Link className='RegisterCardLink' to="/">Назад</Link>
                 <button className='RegisterCardBtnInp'
                 onClick={handleSubmit}>Зарегистрироваться</button>   
             </div>
             {error && <p>{error}</p>}
        </div>

         </div>

    </main>

   
    )
}